import SanityImage from 'content/SanityImage';
import PoiCollectionBlock from 'content/PoiCollectionBlock';
import slugify from 'slugify';
import PoiBlock from 'content/PoiBlock';

const portableTextComponents = {
    block: {
        h2: ({ children = null }) => {
            return (
                <>
                    <div className="scroll-anchor" id={slugify(toPlainText(children), { lower: true })} />
                    <h2 className="font-sans font-bold text-2xl">{children}</h2>
                </>
            );
        }
    },
    types: {
        image: SanityImage,
        poiCollection: PoiCollectionBlock,
        poi: PoiBlock
    }
};

function toPlainText(blocks = []) {
    return (
        blocks
            // loop through each block
            .map((block) => {
                // if it's not a text block with children,
                // return nothing
                if (block._type !== 'block' || !block.children) {
                    return '';
                }
                // loop through the children spans, and join the
                // text strings
                return block.children.map((child) => child.text).join('');
            })
            // join the paragraphs leaving split by two linebreaks
            .join('\n\n')
    );
}
export default portableTextComponents;
